@if (loader.criticalDataLoaded()) {
  @if (!restrictions?.isFullAccountLock()) {
    <router-outlet></router-outlet>
  } @else {
    <app-full-account-lock></app-full-account-lock>
  }
}
